import React from 'react';

const GRID_GUTTER = 20;
const GRID_BLOCKS = 12;

export const Col = ({ children, size, ...rest }) => (
  <div {...rest}>
    {children}

    <style jsx>{`
      div {
        flex-basis: 0;
        flex-grow: 1;
        max-width: 100%;
        padding-left: ${GRID_GUTTER / 2}px;
        padding-right: ${GRID_GUTTER / 2}px;

        ${size &&
          `
          flex: 0 0 ${(size / GRID_BLOCKS) * 100}%;
          max-width: ${(size / GRID_BLOCKS) * 100}%;
        `}
      }
    `}</style>
  </div>
);

export const Row = ({ children, gutter = true, ...rest }) => (
  <div {...rest}>
    {children}

    <style jsx>{`
      div {
        display: flex;
        flex-wrap: wrap;

        ${gutter &&
          `
          margin-right: -${GRID_GUTTER / 2}px;
          margin-left: -${GRID_GUTTER / 2}px;
        `}
      }

      div :global(> div) {
        ${!gutter &&
          `
          padding-left: 0;
          padding-right: 0;
        `}
      }
    `}</style>
  </div>
);
